import { Component } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.css'],
})
export class LoadingSpinner {}
